import _taggedTemplateLiteral from '@babel/runtime/helpers/taggedTemplateLiteral';
import { createGlobalStyle } from '../../components/global-styles.js';
import { printFontFace } from '../utils.js';
import { fontFamily } from './common/fontFamily.js';
import { weights } from './common/weights.js';
import { sizes } from './common/sizes.js';
import { responsiveSizes } from './common/responsiveSizes.js';
import { variants } from './common/variants/index.js';

var _templateObject;
var SBonus = {
  fontFamily: fontFamily,
  defaultSize: '16px',
  defaultLetterSpacing: '0.5px',
  defaultWeight: 400,
  weights: weights,
  sizes: sizes,
  responsiveSizes: responsiveSizes,
  variants: variants,
  CSS: createGlobalStyle(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n\n    ", "\n    ", "\n    ", "\n    ", "\n    ", "\n  "])), printFontFace('SBonus', weights.light, 'normal', 'SBonusUXWEB-Light'), printFontFace('SBonus', weights.regular, 'normal', 'SBonusUXWEB-Regular'), printFontFace('SBonus', weights.medium, 'normal', 'SBonusUXWEB-Medium'), printFontFace('SBonus', weights.bold, 'normal', 'SBonusUXWEB-Bold'), printFontFace('SBonus', weights.extraBold, 'normal', 'SBonusUXWEB-Extrabold'), printFontFace('SBonus', weights.light, 'italic', 'SBonusUX-LightItalic'), printFontFace('SBonus', weights.regular, 'italic', 'SBonusUX-RegularItalic'), printFontFace('SBonus', weights.medium, 'italic', 'SBonusUX-MediumItalic'), printFontFace('SBonus', weights.bold, 'italic', 'SBonusUX-BoldItalic'), printFontFace('SBonus', weights.extraBold, 'italic', 'SBonusUX-ExtraboldItalic'))
};

export { SBonus };
//# sourceMappingURL=index.js.map
